/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseHub } from '../../models/api-response-hub';

export interface GetHubById$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  id: number;
}

export function getHubById(http: HttpClient, rootUrl: string, params: GetHubById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseHub>> {
  const rb = new RequestBuilder(rootUrl, getHubById.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseHub>;
    })
  );
}

getHubById.PATH = '/v1/api/hubs/hub-id/{id}';
